import './quotes-van-expert.scss'

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('o-quotesVanExpert__flickity');
    if (!slider) return;

    const waitForClass = (el, className, timeout = 5000) => new Promise(resolve => {
        if (!el) return resolve(false);
        if (el.classList.contains(className)) return resolve(true);
        const observer = new MutationObserver((mutations, obs) => {
            if (el.classList.contains(className)) {
                obs.disconnect();
                resolve(true);
            }
        });
        observer.observe(el, { attributes: true, attributeFilter: ['class'] });
        setTimeout(() => {
            observer.disconnect();
            resolve(false);
        }, timeout);
    });

    const waitForFlickity = (timeout = 5000) => new Promise(resolve => {
        if (window.Flickity) return resolve(true);
        const interval = setInterval(() => {
            if (window.Flickity) {
                clearInterval(interval);
                resolve(true);
            }
        }, 50);
        setTimeout(() => {
            clearInterval(interval);
            resolve(false);
        }, timeout);
    });

    // Attach pause/resume listeners immediately so `pauze` toggles even if Flickity
    // isn't available yet. When handlers run, resolve Flickity instances dynamically.
    const pause = () => {
        try {
            const f = (window.Flickity && slider) ? Flickity.data(slider) : null;
            if (f && f.player) f.pausePlayer();
        } catch (e) {}
        slider.classList.add('pauze');
    };
    const resume = () => {
        try {
            const f = (window.Flickity && slider) ? Flickity.data(slider) : null;
            if (f && f.options) f.unpausePlayer();
        } catch (e) {}
        slider.classList.remove('pauze');
    };

    ['mouseenter','mouseleave','pointerenter','pointerleave'].forEach(evt => {
        if (evt.includes('enter')) slider.addEventListener(evt, evt.includes('enter') ? pause : resume);
        else slider.addEventListener(evt, evt === 'mouseleave' ? resume : pause);
    });

    // When Flickity is ready (or after a short timeout), set the expert names on dots
    Promise.all([waitForFlickity(), waitForClass(slider, 'flickity-enabled')]).then(() => {
        const dots = slider.querySelectorAll('.flickity-page-dots .flickity-page-dot');
        const slideNames = slider.querySelectorAll('[data-expert]');
        if (!dots.length || !slideNames.length) return;
        dots.forEach((dot, index) => {
            const slide = slideNames[index];
            if (!slide) return;
            const expertName = slide.getAttribute('data-expert') || '';
            dot.textContent = expertName;
        });
    });
});
